/* Common Imports */

import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";

/* Component Imports */

import { useMediaQuery } from "@material-ui/core";
import Testimonial from "../../menu-page/Testimonial";
import Carousel from "@beegru/react-material-ui-carousel";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    margin: '5rem 0rem 5rem 0rem',
    [theme.breakpoints.down('xs')]: {
      margin: '5rem 0rem 0rem 0rem',
    },
    [theme.breakpoints.only('md')]: {
      margin: '5rem 0rem 3rem 0rem',
    },
  },
  sectionTitle: {
    margin: '0rem 0rem 1.5rem 0rem',
    fontWeight: 700,
    fontSize: '2.125rem',
    lineHeight: '3.1875rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.5rem',
      lineHeight: '1.75rem',
      letterSpacing: '0.031rem',
      fontWeight: 500,
    },
  },
  testimonialContainerStyling: {
    width: '400px',
    height: '400px',
    [theme.breakpoints.up('xs')]: {
      width: '350px',
      height: '400px',
    },
  },
  carouselContainer: {
    height: '25rem',
    [theme.breakpoints.only('sm')]: {
      height: '25rem',
    },
    [theme.breakpoints.only('md')]: {
      height: '25rem',
    },
    [theme.breakpoints.only('lg')]: {
      height: '25rem',
    },
    [theme.breakpoints.only('xl')]: {
      height: '25rem',
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: '2rem',
      height: '24rem',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const BreadCarousel = () => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <React.Fragment>
      <div id="testimonials" className={classes.sectionContainer}>
        <div className={classes.carouselContainer}>
          <Carousel
            containerStyling={classes.testimonialContainerStyling}
            animation="slide"
            navButtonsAlwaysInvisible={useMediaQuery(
              theme.breakpoints.down('xs')
            )}
            autoPlay={useMediaQuery(theme.breakpoints.up('sm'))}
            interval={2400}
          >
            <Testimonial
              subTitle="PLAIN BREAD"
              thumbnailLink="/images/products/Bread.png"
            />
            <Testimonial
              subTitle="SWEET BREAD"
              thumbnailLink="/images/products/sweet_bread.png"
            />
            <Testimonial
              subTitle="FRUIT BREAD"
              thumbnailLink="/images/products/fruit_bread.png"
            />
          </Carousel>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BreadCarousel;
